

import { NWfunctionCheck, NWCheck, NWcopyUserDataFile, NWwriteFile } from '../../../nw/NWfunctions.js'
import * as TerrassorConst from '../../../terrassor_const.js'


/* @ngInject */
export class HeaderController {
  /* @ngInject */
  constructor (TerrassorDB) {
  	this.TerrassorDB = TerrassorDB

  }

  $onInit() {

    console.log('HeaderController : init')

  	this.isNW = (typeof(nw) != "undefined")
  	console.log('HeaderController::onInit')
  	this.showTerrassorContext()

  }

  showTerrassorContext() {
    this.TerrassorVersion = (typeof(nw) != "undefined") ? 'version App-NW' : 'sur localhost'
  	this.NWversion = (typeof(nw) != "undefined") ? nw.process.versions['nw'] : ''
    this.dbVersion = this.TerrassorDB.loveField.dbVersion

    this.debugMode = TerrassorConst.MODE_DEBUG
  }


/*
* Copier un fichier de données dans /data/data_eleve.js, puis vider la base et relancer l'alication
*/
importDataFile(isNW) {
	return this.parentSimulator.importDataFile(isNW)
}

/* Charger un chantier vide */
importDataChantier(isNW) {
	return this.parentSimulator.importDataChantier(isNW)
}

  

exportDataFile(isNW) {
	return this.parentSimulator.exportDataFile(isNW)
}

viderBaseEtRecommencer(isNW) {
	return this.parentSimulator.viderBaseEtRecommencer(isNW)
}

editerEpure(isNW) {
	return this.parentSimulator.editerEpure(isNW)
}

/*
*
*/
showDatabaseContent() {
 return this.parentSimulator.showDatabaseContent()
  
}
  

}



// WEBPACK FOOTER //
// ./src/client/common/uiComponents/Header/header.controller.js